import { useEffect, useState } from "react";
import { Download, X } from "lucide-react";

export function InstallBanner() {
  const [evt, setEvt] = useState(null);
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    const onPrompt = (e) => { e.preventDefault(); setEvt(e); };
    window.addEventListener("beforeinstallprompt", onPrompt);
    return () => window.removeEventListener("beforeinstallprompt", onPrompt);
  }, []);

  if (!evt || hidden) return null;

  const install = async () => {
    evt.prompt();
    await evt.userChoice;
    setEvt(null);
  };

  return (
    <div className="install-banner" data-testid="install-banner">
      <div>
        <strong>Pasang aplikasi ini</strong>
        <div className="muted-sm">Buka lebih cepat dari layar utama HP Anda.</div>
      </div>
      <button className="btn-primary sm" onClick={install} data-testid="install-btn"><Download size={14} /> Pasang</button>
      <button className="icon-btn" onClick={() => setHidden(true)} data-testid="install-close"><X size={16} /></button>
    </div>
  );
}
